<template>
  <v-container>
    <v-dialog v-model="openFlag" max-width="800">
      <c-card class="white" :title="onSetDialogTitle">
        <v-row align="center" class="mx-4">
          <v-col cols="3">
            일시
            <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-row align="center">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on}">
                  <v-text-field
                    v-model="maintenanceInfo.date"
                    prepend-icon="event"
                    readonly densd
                    v-on="on"
                  ></v-text-field>
                </template>
                <c-date-picker
                  v-model="maintenanceInfo.date" @input="dateMenu = false" firstDayOfWeek="1" :selectedDate="maintenanceInfo.date"
                  noTitle="true" scrollable="true" locale="ko-kr">
                </c-date-picker>
              </v-menu>
              <c-time-picker
                v-model="maintenanceInfo.time"
                :minute-interval="5"
                :h-range="[0,24]"
                :autoScroll="true"
                :defaultAutoScrollValue="7"
              ></c-time-picker>
            </v-row>
          </v-col>

          <v-col cols="3">
            담당자
            <span class="red--text">*</span></v-col>
          <v-col cols="4">
            <v-radio-group v-model="maintenanceInfo.type" row>
              <v-radio label="기사" value="driver"></v-radio>
              <v-radio label="관리자" value="admin"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="5">
            <v-select v-model="maintenanceInfo.typeValue" :items="typeValueList" item-text="name" return-object></v-select>
          </v-col>

          <v-col cols="3">
            정비처
            <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-menu v-model="locationListMenu" offset-y max-height="300px" max-width="500px" class="my-0">
              <template v-slot:activator="{}">
                <v-row align="center" class="my-0 py-0">
                  <v-col cols="10" class="mt-0 pt-0">
                    <v-text-field v-model="maintenanceInfo.location" :rules="[rules.requiredCharacter]" placeholder="정비처를 검색해주세요." @keyup.enter="onSetAddress" hide-details></v-text-field>
                  </v-col>
                  <v-col>
                    <c-btn outlined color="blue" @click="onSetAddress">검색</c-btn>
                  </v-col>
                </v-row>
              </template>
              <v-list >
                <v-list-item
                  v-for="(item, index) in locationList"
                  :key="index"
                  @click="onSelectAddr(item)"
                >
                  <v-icon class="pr-3" color="blue">place</v-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{item.placeName}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{item.address}}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.roadAddress">
                      <v-chip x-small shaped pill label> 지번</v-chip> {{item.roadAddress}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <v-col cols="3">
            금액 (원)
            <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-text-field v-model="maintenanceInfo.price" style="display: inline-block"
                          :rules="[rules.numberOnly]"></v-text-field> 원
          </v-col>

          <v-col cols="3">
            주요 정비 내역
            <span class="red--text">*</span>
          </v-col>
          <v-col cols="9">
            <v-row class="mb-3">
              <v-select v-model="maintenanceInfo.maintenanceList" :items="maintenanceItemList" label="점검 내역"
                        multiple return-object deletable-chips chips dense hide-details></v-select>
              <v-text-field v-model="maintenanceText" class="my-3" dense v-if="maintenanceTextFlag"  prefix="기타:" hide-details filled ></v-text-field>
            </v-row>
            <v-row>
              <v-select v-model="maintenanceInfo.changeList" :items="maintenanceItemList" label=" 교체 내역"
                        multiple return-object deletable-chips chips item-color="blue" hide-details></v-select>
              <v-text-field v-model="changeText" class="my-3" dense v-if="changeTextFlag"  prefix="기타:" hide-details filled ></v-text-field>

            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <c-btn v-if="isNew" outlined color="blue" @click="onAddMaintenance" class="mx-2"> 등록</c-btn>
          <c-btn v-else outlined color="blue" @click="onUpdateMaintenance" class="mx-2"> 수정</c-btn>
          <c-btn @click="openFlag=false" outlined color="black"> 닫기</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: undefined
      },
      defaultInfo: {
        type: Object,
        default: null
      },
      adminList: {
        type: Array,
        default: null
      },
      driverList: {
        type: Array,
        default: null
      }
    },
    data: () => ({
      openFlag: false,
      isNew: true,
      dateMenu: false,
      maintenanceInfo: {
        date: '',
        time: '',
        type: '',
        typeValue: '',
        location: '',
        price: '',
        maintenanceList: [],
        changeList: [],
        changeEtc: '',
        maintenanceEtc: ''
      },
      maintenanceItemList: [],

      typeValueList: [],
      maintenanceTextFlag: false,
      changeTextFlag: false,
      maintenanceText: '',
      changeText: '',
      rules: {
        numberOnly: (value) => !(/[^0-9]/g).test(value) || '숫자만 입력가능합니다.',
        requiredCharacter: (value) => value && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)|| '정비처를 올바르게 입력해주세요.',
      },
      locationList: [],
      locationListMenu:false,
    }),
    watch: {
      open(val) {
        this.initData();
        if (val && this.defaultInfo.id) {
          this.isNew = false;
          this.maintenanceInfo = {...this.defaultInfo};
          this.maintenanceInfo.maintenanceList = this.defaultInfo.maintenanceListObject ? JSON.parse(this.defaultInfo.maintenanceListObject) : '';
          this.maintenanceInfo.changeList = this.defaultInfo.changeListObject ? JSON.parse(this.defaultInfo.changeListObject) : '';
          this.maintenanceInfo.typeValue = this.defaultInfo.type === 'admin' ? this.defaultInfo.admin : this.defaultInfo.driver;
        }
        this.openFlag = val;
      },
      openFlag(val) {
        if (!val) {
          this.defaultInfo.id = null;
          this.isNew = true;
        }
        this.$emit('update:open', val);
      },
      defaultInfo(val) {
        this.$emit('update:defaultInfo', val)
      },
      'maintenanceInfo.type'(val) {
        if (val === 'admin') {
          this.typeValueList = this.adminList;
        } else {
          this.typeValueList = this.driverList;
        }
      },
      'maintenanceInfo.maintenanceList'(val) {
        if(val.length>0) {
          let res = val.filter(item => item.value === 'etc');
          if (res.length > 0) {
            this.maintenanceTextFlag = true;
            if (this.maintenanceInfo.maintenanceEtc) {
              this.maintenanceText = this.maintenanceInfo.maintenanceEtc.substring(3);
            }
          } else {
            this.maintenanceTextFlag = false;
            this.maintenanceText = null;
          }
        }

      },
      'maintenanceInfo.changeList'(val) {
        if(val.length>0) {
          let res = val.filter(item => item.value === 'etc');
          if (res.length > 0) {
            this.changeTextFlag = true;
            if (this.maintenanceInfo.changeEtc) {
              this.changeText = this.maintenanceInfo.changeEtc.substring(3);
            }
          } else {
            this.changeTextFlag = false;
            this.changeText = null;
          }
        }
      }

    },
    computed: {
      onSetDialogTitle() {
        return this.isNew ? '정비 내역 추가' : '정비 내역 수정';
      },
    },
    methods: {
      initData() {
        this.maintenanceInfo = {
          date: this.$func.curDateString(),
          time: '00:00',
          type: 'admin',
          typeValue: '',
          location: '',
          price: '',
          maintenanceList: [],
          changeList: [],
          changeEtc: '',
          maintenanceEtc: '',
        };
        this.maintenanceItemList= [
          {text: '정기점검', value: 'regularInspection'},
          {text: '엔진오일', value: 'engineOil'},
          {text: '와이퍼', value: 'wiper'},
          {text: '에어컨 필터', value: 'acFilter'},
          {text: '휠 얼라이먼트', value: 'wheelAlignment'},
          {text: '전륜 타이어', value: 'frontTier'},
          {text: '후륜 타이어', value: 'rearTier'},
          {text: '배터리', value: 'battery'},
          {text: '브레이크 패드/라이닝', value: 'breakPad'},
          {text: '미션 오일', value: 'missionOil'},
          {text: '브레이크 오일', value: 'breakOil'},
          {text: '냉각수', value: 'coolant'},
          {text: '등화장치', value: 'beam'},
          {text: '기타', value: 'etc'},
        ];
        this.isNew = true;
        this.maintenanceTextFlag = false;
        this.changeTextFlag= false;
        this.maintenanceText= '';
        this.changeText = '';
        this.locationList= [];
        this.locationListMenu= false;
      },
      nullCheck(){
        if(!this.maintenanceInfo.time || !this.maintenanceInfo.date || !this.maintenanceInfo.type || !this.maintenanceInfo.typeValue || !this.maintenanceInfo.location
          || !this.maintenanceInfo.location || !this.maintenanceInfo.price || (this.maintenanceInfo.maintenanceList.length < 1 && this.maintenanceList.changeList.length < 1)) {
          return false;
        }
        return true;
      },
      regxCheck() {
        if((/[^0-9]/g).test(this.maintenanceInfo.price)|| !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.maintenanceInfo.location)) {
          return false;
        }
        return true;
      },
      onAddMaintenance() {
        if(!this.nullCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        if(!this.regxCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '입력양식이 올바르지 않습니다.'});
          return;
        }
        if(this.maintenanceTextFlag) {
          this.maintenanceInfo.maintenanceList.forEach((item) => {
            if(item.value === 'etc') {
              item.text = '기타:' + this.maintenanceText;
            }
          });
          this.maintenanceInfo['maintenanceEtc'] = '기타:' + this.maintenanceText;

        }
        if(this.changeTextFlag) {
          this.maintenanceInfo.changeList.forEach((item) => {
            if(item.value === 'etc') {
              item.text = '기타:' + this.changeText;
            }
          });
          this.maintenanceInfo['changeEtc'] = '기타:' + this.changeText;

        }
        this.open = false;
        this.$emit('reqAddMaintenance', this.maintenanceInfo);
      },
      onUpdateMaintenance() {
        if(!this.nullCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        if(!this.regxCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '입력양식이 올바르지 않습니다.'});
          return;
        }

        let item = {...this.defaultInfo};
        this.open = false;
        this.maintenanceInfo['id'] = item.id;

        let originM = JSON.parse(item.maintenanceListObject);
        let originC = JSON.parse(item.changeListObject);
        let originVal = [];

        let combined = originM.concat(originC);
        for (let idx in combined) {
          originVal.push(combined[idx].value)
        }
        if(this.maintenanceTextFlag) {
          this.maintenanceInfo.maintenanceList.forEach((item) => {
            if(item.value === 'etc') {
              item.text = '기타:' + this.maintenanceText;
            }
          });
          this.maintenanceInfo['maintenanceEtc'] = '기타:' + this.maintenanceText;

        }
        if(this.changeTextFlag) {
          this.maintenanceInfo.changeList.forEach((item) => {
            if(item.value === 'etc') {
              item.text = '기타:' + this.changeText;
            }
          });
          this.maintenanceInfo['changeEtc'] = '기타:' + this.changeText;

        }
        // this.maintenanceInfo['originMaintenanceVal'] = originVal.join();
        // if (this.maintenanceTextFlag) {
        //   this.maintenanceInfo['maintenanceEtc'] = '기타:' + this.maintenanceText;
        // }
        // if (this.changeTextFlag) {
        //   this.maintenanceInfo['changeEtc'] = '기타:' + this.changeText;


        this.maintenanceInfo['originMaintenanceVal'] = originVal.join();
          this.$emit('reqUpdateMaintenance', this.maintenanceInfo);
        },
        async onSetAddress() {
          const location = this.maintenanceInfo.location;
          let ps = new kakao.maps.services.Places();

          if (!(location.replace(/^\s+|\s+$/g, ''))) {
            this.$store.commit('snackbar', {color:'blue', msg:'검색어를 입력해주세요.'});
            return false;
          }

          let lat = this.$store.state.userInfo.centerPoint.split(',')[1];
          let lng = this.$store.state.userInfo.centerPoint.split(',')[0];
          try {
            await ps.keywordSearch(location, (data, status) => {
              if (status === kakao.maps.services.Status.ZERO_RESULT) {
                this.$store.commit('snackbar', {msg: '검색 결과가 존재하지 않습니다.'});
              } else if (status === kakao.maps.services.Status.ERROR) {
                this.$store.commit('snackbar', {msg: '검색 중 오류가 발생했습니다.'});
              } else if(status === kakao.maps.services.Status.OK) {
                for(let i in data) {
                  let item = data[i];
                  this.locationList.push({
                    placeName: item.place_name,
                    address: item.address_name,
                    roadAddress : item.road_address_name,
                  })
                }
                this.locationListMenu = true;
              }
            }, {
              x: lng,
              y: lat
            });

          } catch (err) {
            this.$store.commit('snackbar', {where : 'MaintenanceCUDialog onSetAddress'})
          }
        },
        onSelectAddr(data) {
          this.maintenanceInfo.location = data.placeName;
        }
      }

  }
</script>

<style scoped>

</style>